import { TKey } from "./translationKeys";

export const en = {
  replace_photo: "Replace photo",
  upload_photo: "Upload photo",
  go_to_plan: "Go to plan",
  home: "Home Screen",
  profile: "Profile",

  home_intro_1: "The ONLY tool needed to plan your next happening.",
  home_intro_2: "No login required and free!",
  home_your_planiras: "Your planiras",
  home_start_planira_1: "Start Planira",
  home_start_planira_2:
    "Find a suitable template below to get started planning your new adventure",
  home_no_planiras: "Nothing yet",
  home_no_planiras_message:
    "We couldn't find any previously visited Planiras on this device.",
  home_sign_in_hint:
    "If you have registered your email you can try sign in below!",

  home_create_new: "CREATE NEW PLANIRA",

  sign_in_box_confirm_title: "Are you sure?",
  sign_in_box_confirm_description:
    "You will be signed out and need your password to login again.",
  sign_in_box_sign_out: "Sign out",
  sign_in_box_returning_user: "Returning user?",
  sign_in_box_returning_user_message:
    "Maximize the potential of Planira by signing in to effortlessly track all your Planiras. While Planira functions brilliantly without signup, signing in ensures seamless access to your Planiras.",
  sign_in_box_sign_in: "Sign in",

  plan_add_step_cta_question: "Would you like to proceed with the next step?",
  plan_add_step_cta_description:
    "Complete this action to move forward in your plan.",
  plan_add_step_cta_deny: "No",
  plan_add_step_cta_accept: "Yes! Let's do this",
  plan_add_step_outro_title: "You are all set!",
  plan_add_step_outro_description:
    "Fantastic work! You are all set for this time.",
  plan_add_step_general_question: "Add another step?",
  plan_add_step_general_description:
    "Add another step if you have more things to plan for right away.",
  plan_add_step_general_accept: "Yes! Let's do this",

  plan_hotels_tips_waiting_title: "Waiting to help out...",
  plan_hotels_tips_waiting_description:
    "When we have enough information, we will show you tips here of where to stay during your adventure.",

  create_screen_planira_full_title: "Full Planira",
  create_screen_planira_full_description:
    "Dive into detailed planning for your next adventure.",
  create_screen_planira_full_tips:
    "Full Planira is designed for comprehensive planning needs. Start with a full setup to manage multiple aspects of your event or project, ideal for detailed and complex planning.",
  create_screen_planira_quickstart_title: "Start planning",
  create_screen_planira_quickstart_description:
    "Choose a starting point to plan your perfect experience. Start simple or dive into full details — add more as you go!",
  create_screen_more_experiences: "More experiences",
  create_screen_more_experiences_description:
    "We have {{count}}+ more adventures prepared for you here",

  [TKey.ActivityStateSetToDone]: "Was set to done!",
  [TKey.ActivityStateSetToPlanning]: "Was reset to planning",
  [TKey.ActivityEmojiChanged]: "Changed icon %oldValue% -> %newValue%",
  [TKey.ActivityDescriptionChanged]: "Updated the description",
  [TKey.ActivityTitleChange]: "Updated the title from %oldValue% to %newValue%",
  [TKey.ActivityRestoredCard]: "Restored this from the archive",
  [TKey.ActivityArchivedCard]: "Moved this to the archive",
  [TKey.ActivityMovedCard]: "Moved to group %newValue% from %oldValue%",
  [TKey.ActivityUpdatedTextInPoll]:
    "Updated the text from %oldValue% to %newValue%",
  [TKey.ActivityPlanInfoDescriptionUpdated]:
    "Updated the description from %oldValue% to %newValue%",
  [TKey.ActivityPlanInfoImageUpdated]: "Updated the image",
  [TKey.ActivityUpdatedDescriptionInLocation]:
    "Updated the description from %oldValue% to %newValue% at location %location%",
  [TKey.ActivityUpdatedPositionInLocation]:
    "Updated the position for location %location%",
  [TKey.ActivityUpdatedLocation]: "Updated the location %location%",
  [TKey.ActivityInfoTextUpdated]:
    "Updated the description from %oldValue% to %newValue%",
  [TKey.ActivityPollOptionUpdated]:
    "Updated option from %oldValue% to %newValue%",
  [TKey.ActivityRsvpUpdated]: 'Updated RSVP status to "%newValue%"',
  [TKey.ActivityCheckboxAssignedTo]: "Assigned %label% to %displayName%",
  [TKey.ActivityCheckboxAssignedRemoved]:
    "Removed %displayName% as assigned to %label%",
  [TKey.ActivityCheckboxLabelUpdated]:
    "Updated the option %oldValue% to %newValue%",
  [TKey.ActivityCheckboxCompleted]: "Completed %label%",
  [TKey.ActivityCheckboxReset]: "Did reset %label%",
  [TKey.ActivityCalendarDatesSet]: "Set available dates to %dates%",
  [TKey.ActivityDateDueAssignedTo]: "Assigned %label% to %displayName%",
  [TKey.ActivityDateDueAssignedRemoved]:
    "Removed %displayName% as assigned to %label%",
  [TKey.ActivityDateDueDescriptionUpdated]:
    "Updated the description from %oldValue% to %newValue%",
  [TKey.ActivityDateDueCompleted]: "Was set to completed!",
  [TKey.ActivityDateDueReset]: "Was reopened",
  [TKey.ActivityExpensesSettlementAdded]:
    "Added settlement from %debtorName% → %creditorName% (%amount%)",
  [TKey.ActivityExpensesExpenseAdded]: "Paid %amount% %title%",
  [TKey.ActivityExpensesExpenseUpdated]:
    "Updated expense %title% %oldAmount% -> %amount% ",
  [TKey.ActivityCheckboxAdded]: "Added option %label%",
  [TKey.ActivityRatingSet]: "Rated option %label% as %rating%",
  [TKey.ActivityCommentAdded]: "%comment%",
  [TKey.ActivityPollOptionAdded]: "Added %label% as option",
  [TKey.ActivityLocationAdded]: "Added location %label% as option",

  [TKey.ActivityModuleAdded]: "Added step %label%",
  [TKey.ActivityModuleCopied]: "Copied step %label%",
  [TKey.ActivityPollVotedFor]: "Voted for option %label%",
  [TKey.ActivityPollStoppedVotingFor]: "Stopped voting for option %label%",
  [TKey.ActivityDataWithLabelDeleted]: "Deleted %label%",
  [TKey.ActivityTrackerItemAdded]: "Added %type% x %amount% %comment%",
  [TKey.ActivityReminderAssignedTo]: "Assigned %label% to %displayName%",
  [TKey.ActivityReminderAssignedRemoved]:
    "Removed %displayName% as assigned to %label%",
  [TKey.ActivityReminderDescriptionUpdated]:
    "Updated the description from %oldValue% to %newValue%",
  [TKey.ActivityReminderCompleted]: "Was set to completed!",
  [TKey.ActivityReminderReset]: "Was reopened",
  [TKey.BusinessFeedItemPosted]: "%comment%",
  [TKey.BusinessFeedCommentPosted]: "%comment%",
  [TKey.BusinessFeedCommentReplyPosted]: "%comment%",
} as const;

export type TranslationKeys = keyof typeof en;
